import styled from 'styled-components';

const Svg = styled.svg`
  ${({ theme: { spacing } }) => `
    width: ${spacing(4)};
    height: ${spacing(4)};
  `}
`;

type Props = {
  color: string;
  className?: string;
};

export const Close = ({ className = '', color }: Props) => (
  <Svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 6L18 18" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M18 6L6 18" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </Svg>
);
